import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { MONEY_TYPES } from 'constants'

import styles from './Item.scss'

const views = ['journal', 'challenges', 'management']
const currencies = ['industrial', MONEY_TYPES.gold, MONEY_TYPES.crystal]

const Item = (props) => {
    const className = classNames(styles.base, styles[`base__${props.type}`], {
        [styles.base__currency]: currencies.includes(props.type),
        [styles.base__selected]: props.selected,
    })

    return (
        <div
            onClick={props.handleClick}
            onMouseEnter={props.handleHover}
            className={className}
            data-tip={!!props.tooltipId}
            data-for={props.tooltipId}
        >
            <div className={styles.holder}>
                <div className={styles.title}>
                    <span className={styles.icon} />
                    <span className={styles.caption}>
                        {props.title}
                    </span>
                </div>
                {props.contents &&
                    <div className={styles.contents}>
                        {props.contents}
                    </div>
                }
            </div>
        </div>
    )
}

Item.propTypes = {
    selected: PropTypes.bool,
    title: PropTypes.node.isRequired,
    contents: PropTypes.node,
    type: PropTypes.oneOf([...views, ...currencies]).isRequired,
    handleClick: PropTypes.func,
    handleHover: PropTypes.func,
    tooltipId: PropTypes.string,
}

export default Item



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/Item/Item.jsx